import { Reducer } from 'umi';
import { initBuriedPoint } from '../../operationLog/buriedPoint';

const namespace = 'opinionMenu';
initBuriedPoint();

type stateType = {
  menuExpand: boolean;
  selectMenuItem: string | null;
};

const customModel: {
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
    toggleMenuExpand: Reducer<stateType>;
    changeSelectMenuItem: Reducer<stateType>;
    resetSelectMenuItem: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    menuExpand: true,
    selectMenuItem: null
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
    toggleMenuExpand(state: stateType, { payload = {} }) {
      return { ...state, menuExpand: !state.menuExpand, ...payload };
    },
    changeSelectMenuItem(state: stateType, { payload }: any) {
      return { ...state, selectMenuItem: payload };
    },
    resetSelectMenuItem(state: stateType) {
      return { ...state, selectMenuItem: null };
    },
  },
};

export default customModel;
